export var DomainPrivacy;
(function (DomainPrivacy) {
    DomainPrivacy["UNKNOWN_PRIVACY"] = "UNKNOWN_PRIVACY";
    /** rivacy feature not purchased for this domain */
    DomainPrivacy["NOT_PURCHASED"] = "NOT_PURCHASED";
    /** rivacy feature purchased and enabled */
    DomainPrivacy["PRIVACY_TURNED_ON"] = "PRIVACY_TURNED_ON";
    /** rivacy feature purchased and disabled */
    DomainPrivacy["PRIVACY_TURNED_OFF"] = "PRIVACY_TURNED_OFF";
})(DomainPrivacy || (DomainPrivacy = {}));
export var VendorType;
(function (VendorType) {
    VendorType["UNKNOWN_VENDOR"] = "UNKNOWN_VENDOR";
    /** G-Suite/Workspace used for mail */
    VendorType["GOOGLE"] = "GOOGLE";
    /** MSN Office Suite used for mail */
    VendorType["MSN"] = "MSN";
})(VendorType || (VendorType = {}));
export var DigitalGoodsType;
(function (DigitalGoodsType) {
    DigitalGoodsType["UNKNOWN_DIGITAL_GOOD_TYPE"] = "UNKNOWN_DIGITAL_GOOD_TYPE";
    DigitalGoodsType["IMAGE"] = "IMAGE";
    DigitalGoodsType["VIDEO"] = "VIDEO";
    DigitalGoodsType["LOGO"] = "LOGO";
})(DigitalGoodsType || (DigitalGoodsType = {}));
export var ProviderName;
(function (ProviderName) {
    ProviderName["UNKNOWN_BILLING_PROVIDER"] = "UNKNOWN_BILLING_PROVIDER";
    ProviderName["SBS"] = "SBS";
    ProviderName["LICENSER"] = "LICENSER";
    ProviderName["BASS"] = "BASS";
    ProviderName["RESELLER"] = "RESELLER";
    ProviderName["RECURRING_INVOICES"] = "RECURRING_INVOICES";
})(ProviderName || (ProviderName = {}));
export var AssetStatus;
(function (AssetStatus) {
    AssetStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** SBS service status: ACTIVE, STARTED, PENDING_RENEWAL, SUBMITTED, COMPLETED, WORK_IN_PROGRESS, COLLECTIONS, SUSPENDED */
    AssetStatus["ACTIVE"] = "ACTIVE";
    /** SBS service status: CANCELED , EXPIRED, STOPPED FAILED, FRAUDULENT, PENDING */
    AssetStatus["NOT_ACTIVE"] = "NOT_ACTIVE";
    /** SBS service status: TRANSFERRED */
    AssetStatus["TRANSFERRED"] = "TRANSFERRED";
    /** Used when creating subscription for product that was initially purchased by a non real time payment method such as Boleto ot SEPA and can take a while to be delivered */
    AssetStatus["PENDING"] = "PENDING";
})(AssetStatus || (AssetStatus = {}));
export var RenewalType;
(function (RenewalType) {
    RenewalType["UNKNOWN_RENEWAL_TYPE"] = "UNKNOWN_RENEWAL_TYPE";
    /** Subscription renewed when current period ends with automatic payment method, for example credit card */
    RenewalType["AUTO_RENEW_ON"] = "AUTO_RENEW_ON";
    /** Subscription is turned off at current period end date */
    RenewalType["AUTO_RENEW_OFF"] = "AUTO_RENEW_OFF";
    /** Subscription is renewed when current period ends only if paid for manually */
    RenewalType["MANUAL"] = "MANUAL";
})(RenewalType || (RenewalType = {}));
export var DurationUnit;
(function (DurationUnit) {
    /** unknown interval unit */
    DurationUnit["UNKNOWN_UNIT"] = "UNKNOWN_UNIT";
    /** day */
    DurationUnit["DAY"] = "DAY";
    /** week */
    DurationUnit["WEEK"] = "WEEK";
    /** month */
    DurationUnit["MONTH"] = "MONTH";
    /** year */
    DurationUnit["YEAR"] = "YEAR";
})(DurationUnit || (DurationUnit = {}));
export var CycleType;
(function (CycleType) {
    CycleType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    CycleType["ONE_TIME"] = "ONE_TIME";
    CycleType["RECURRING"] = "RECURRING";
})(CycleType || (CycleType = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    /** Billing system status: VOID or Unknown type */
    PaymentStatus["UNKNOWN_PAYMENT_STATUS"] = "UNKNOWN_PAYMENT_STATUS";
    /** Billing system status: Closed */
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["REFUNDED"] = "REFUNDED";
    /** Billing system invoice status: CREDIT_NOTE, ERROR_CHARGES, DECLINED_CHARGES , BAD_DEBT */
    PaymentStatus["CHARGE_ATTEMPT_FAILED"] = "CHARGE_ATTEMPT_FAILED";
    /** Billing system invoice status = Due , PAYMENT_IN_PROGRESS */
    PaymentStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** Invoice was never created for asset, mostly transferred assets */
    PaymentStatus["NO_PAYMENT"] = "NO_PAYMENT";
    /** Manual_payment_pending? */
    PaymentStatus["NOT_BILLABLE"] = "NOT_BILLABLE";
})(PaymentStatus || (PaymentStatus = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var IntervalUnit;
(function (IntervalUnit) {
    /** unknown interval unit */
    IntervalUnit["UNKNOWN"] = "UNKNOWN";
    /** day */
    IntervalUnit["DAY"] = "DAY";
    /** week */
    IntervalUnit["WEEK"] = "WEEK";
    /** month */
    IntervalUnit["MONTH"] = "MONTH";
    /** year */
    IntervalUnit["YEAR"] = "YEAR";
})(IntervalUnit || (IntervalUnit = {}));
/** service statuses */
export var ServiceStatus;
(function (ServiceStatus) {
    ServiceStatus["UNKNOWN"] = "UNKNOWN";
    ServiceStatus["ACTIVE"] = "ACTIVE";
    ServiceStatus["CANCELED"] = "CANCELED";
    ServiceStatus["FRAUDULENT"] = "FRAUDULENT";
    ServiceStatus["SUSPENDED"] = "SUSPENDED";
    ServiceStatus["UNPAID"] = "UNPAID";
})(ServiceStatus || (ServiceStatus = {}));
export var RecurringTypeMessageRecurringType;
(function (RecurringTypeMessageRecurringType) {
    RecurringTypeMessageRecurringType["UNKNOWN"] = "UNKNOWN";
    RecurringTypeMessageRecurringType["MANUAL"] = "MANUAL";
    RecurringTypeMessageRecurringType["OFF"] = "OFF";
    RecurringTypeMessageRecurringType["AUTO"] = "AUTO";
})(RecurringTypeMessageRecurringType || (RecurringTypeMessageRecurringType = {}));
export var CardBrand;
(function (CardBrand) {
    CardBrand["UNKNOWN"] = "UNKNOWN";
    CardBrand["VISA"] = "VISA";
    CardBrand["MASTERCARD"] = "MASTERCARD";
    /** American Express */
    CardBrand["AMEX"] = "AMEX";
    CardBrand["DISCOVER"] = "DISCOVER";
    CardBrand["JCB"] = "JCB";
    /** Diners Club */
    CardBrand["DINERS"] = "DINERS";
    /** Carte Bancaire */
    CardBrand["CARTE_BLUE"] = "CARTE_BLUE";
    CardBrand["ELO"] = "ELO";
    /** deprecated, please use UNIONPAY */
    CardBrand["UNION_PAY"] = "UNION_PAY";
    CardBrand["UNIONPAY"] = "UNIONPAY";
})(CardBrand || (CardBrand = {}));
export var DirectDebitBrand;
(function (DirectDebitBrand) {
    DirectDebitBrand["UNKNOWN"] = "UNKNOWN";
    DirectDebitBrand["SEPA"] = "SEPA";
})(DirectDebitBrand || (DirectDebitBrand = {}));
export var CashType;
(function (CashType) {
    CashType["UNKNOWN"] = "UNKNOWN";
    CashType["BOLETO"] = "BOLETO";
})(CashType || (CashType = {}));
export var BankTransferType;
(function (BankTransferType) {
    BankTransferType["UNKNOWN"] = "UNKNOWN";
    BankTransferType["SOFORT"] = "SOFORT";
})(BankTransferType || (BankTransferType = {}));
export var RecurringType;
(function (RecurringType) {
    RecurringType["None"] = "None";
    RecurringType["AUTO"] = "AUTO";
    RecurringType["HYBRID"] = "HYBRID";
})(RecurringType || (RecurringType = {}));
export var AlternativePaymentMethodType;
(function (AlternativePaymentMethodType) {
    AlternativePaymentMethodType["UNKNOWN"] = "UNKNOWN";
    AlternativePaymentMethodType["PAYPAL"] = "PAYPAL";
    AlternativePaymentMethodType["EXTERNAL_CREDIT_CARD"] = "EXTERNAL_CREDIT_CARD";
    AlternativePaymentMethodType["SOFORT"] = "SOFORT";
    AlternativePaymentMethodType["SEPA_OFFLINE"] = "SEPA_OFFLINE";
    AlternativePaymentMethodType["RAZORPAY"] = "RAZORPAY";
})(AlternativePaymentMethodType || (AlternativePaymentMethodType = {}));
export var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["UNKNOWN"] = "UNKNOWN";
    PaymentMethodType["PAYPAL"] = "PAYPAL";
    PaymentMethodType["EXTERNAL_CREDIT_CARD"] = "EXTERNAL_CREDIT_CARD";
    PaymentMethodType["SOFORT"] = "SOFORT";
    PaymentMethodType["SEPA_OFFLINE"] = "SEPA_OFFLINE";
    PaymentMethodType["RAZORPAY"] = "RAZORPAY";
})(PaymentMethodType || (PaymentMethodType = {}));
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["UNKNOWN"] = "UNKNOWN";
    InvoiceStatus["DRAFT"] = "DRAFT";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["VOID"] = "VOID";
    InvoiceStatus["REFUNDED"] = "REFUNDED";
    InvoiceStatus["DECLINED"] = "DECLINED";
    InvoiceStatus["PAYMENT_IN_PROGRESS"] = "PAYMENT_IN_PROGRESS";
})(InvoiceStatus || (InvoiceStatus = {}));
export var SubscriptionStatusEnumSubscriptionStatus;
(function (SubscriptionStatusEnumSubscriptionStatus) {
    SubscriptionStatusEnumSubscriptionStatus["UNKNOWN"] = "UNKNOWN";
    /** Subscription created in this status, but hasn't been paid for yet. Filtered out from subscriptions querying. */
    SubscriptionStatusEnumSubscriptionStatus["DRAFT"] = "DRAFT";
    /** Subscription that will be active in future. */
    SubscriptionStatusEnumSubscriptionStatus["PENDING"] = "PENDING";
    /** Subscription is active */
    SubscriptionStatusEnumSubscriptionStatus["ACTIVE"] = "ACTIVE";
    /** Subscription is paused */
    SubscriptionStatusEnumSubscriptionStatus["PAUSED"] = "PAUSED";
    /** Subscription was ended */
    SubscriptionStatusEnumSubscriptionStatus["ENDED"] = "ENDED";
    /** Subscription was canceled or auto-renew off. Ended before its time. */
    SubscriptionStatusEnumSubscriptionStatus["CANCELED"] = "CANCELED";
})(SubscriptionStatusEnumSubscriptionStatus || (SubscriptionStatusEnumSubscriptionStatus = {}));
export var CollectionMethod;
(function (CollectionMethod) {
    CollectionMethod["UNKNOWN"] = "UNKNOWN";
    /** Subscriber automatically charged */
    CollectionMethod["AUTO_CHARGE"] = "AUTO_CHARGE";
    /** Payments manually collected and managed by owner */
    CollectionMethod["OFFLINE"] = "OFFLINE";
    /** Payment will be collected somehow. Billing only issues invoice per cycle. */
    CollectionMethod["SEND_INVOICE"] = "SEND_INVOICE";
    /** Payment will be collected externally */
    CollectionMethod["EXTERNAL"] = "EXTERNAL";
})(CollectionMethod || (CollectionMethod = {}));
export var DurationUnitEnumDurationUnit;
(function (DurationUnitEnumDurationUnit) {
    DurationUnitEnumDurationUnit["UNKNOWN"] = "UNKNOWN";
    DurationUnitEnumDurationUnit["DAY"] = "DAY";
    DurationUnitEnumDurationUnit["WEEK"] = "WEEK";
    DurationUnitEnumDurationUnit["MONTH"] = "MONTH";
    DurationUnitEnumDurationUnit["YEAR"] = "YEAR";
})(DurationUnitEnumDurationUnit || (DurationUnitEnumDurationUnit = {}));
export var AdditionalFeeTrigger;
(function (AdditionalFeeTrigger) {
    AdditionalFeeTrigger["UNKNOWN"] = "UNKNOWN";
    /** Charge upon subscription first payment */
    AdditionalFeeTrigger["FIRST_PAYMENT"] = "FIRST_PAYMENT";
})(AdditionalFeeTrigger || (AdditionalFeeTrigger = {}));
export var TaxableAddressType;
(function (TaxableAddressType) {
    TaxableAddressType["UNKNOWN"] = "UNKNOWN";
    /** Tax will be calculated using a single address */
    TaxableAddressType["BUSINESS"] = "BUSINESS";
    /** Tax will be calculated using multiple address (from BUSINESS to BILLING) */
    TaxableAddressType["BILLING"] = "BILLING";
    /** Tax will be calculated using multiple address (from BUSINESS to SHIPPING) */
    TaxableAddressType["SHIPPING"] = "SHIPPING";
})(TaxableAddressType || (TaxableAddressType = {}));
export var PaymentStatusEnumPaymentStatus;
(function (PaymentStatusEnumPaymentStatus) {
    /** Payment status unknown */
    PaymentStatusEnumPaymentStatus["UNKNOWN"] = "UNKNOWN";
    /** Payment has not been paid */
    PaymentStatusEnumPaymentStatus["UNPAID"] = "UNPAID";
    /** Payment has been paid // TODO: p13n review: we are not sending event when in SEND_INVOICE mode cycle was paid. should we and which event? */
    PaymentStatusEnumPaymentStatus["PAID"] = "PAID";
    /** Payment failed */
    PaymentStatusEnumPaymentStatus["FAILED"] = "FAILED";
})(PaymentStatusEnumPaymentStatus || (PaymentStatusEnumPaymentStatus = {}));
export var PausePolicy;
(function (PausePolicy) {
    PausePolicy["NONE"] = "NONE";
    /** Pause the payment and the service. When resuming, the subscription end date is extended by the number of cycles postponed, and if the pause happened in a middle of a cycle, the payment date is postponed by the amount of days that already paid. */
    PausePolicy["SERVICE_AND_PAYMENTS"] = "SERVICE_AND_PAYMENTS";
    /** Pause the service and continue the billing. When resuming, extend the service by the time that was paused */
    PausePolicy["SERVICE_ONLY"] = "SERVICE_ONLY";
})(PausePolicy || (PausePolicy = {}));
export var PauseAt;
(function (PauseAt) {
    /** Cancel scheduled pause */
    PauseAt["NONE"] = "NONE";
    /** Pause the subscription now */
    PauseAt["IMMEDIATELY"] = "IMMEDIATELY";
    /** Pause the subscription at the next billing date */
    PauseAt["NEXT_BILLING_DATE"] = "NEXT_BILLING_DATE";
    /** A specific date must be defined in Schedule.specific_date */
    PauseAt["SPECIFIC_DATE"] = "SPECIFIC_DATE";
    /** The number of cycles must be defined in Schedule.number_of_cycles */
    PauseAt["NUMBER_OF_CYCLES_FROM_TODAY"] = "NUMBER_OF_CYCLES_FROM_TODAY";
})(PauseAt || (PauseAt = {}));
export var ResumeAt;
(function (ResumeAt) {
    /** Cancel scheduled resume */
    ResumeAt["NONE"] = "NONE";
    /** Resume the subscription now */
    ResumeAt["IMMEDIATELY"] = "IMMEDIATELY";
    /** Resume the subscription at the next billing date */
    ResumeAt["NEXT_BILLING_DATE"] = "NEXT_BILLING_DATE";
    /** A specific date must be defined in Schedule.specific_date */
    ResumeAt["SPECIFIC_DATE"] = "SPECIFIC_DATE";
})(ResumeAt || (ResumeAt = {}));
export var HistoryActionInitiator;
(function (HistoryActionInitiator) {
    HistoryActionInitiator["UNDEFINED"] = "UNDEFINED";
    HistoryActionInitiator["BUSINESS"] = "BUSINESS";
    HistoryActionInitiator["CUSTOMER"] = "CUSTOMER";
    HistoryActionInitiator["SYSTEM"] = "SYSTEM";
    HistoryActionInitiator["PAYMENT_FAILURE"] = "PAYMENT_FAILURE";
})(HistoryActionInitiator || (HistoryActionInitiator = {}));
export var ItemCategory;
(function (ItemCategory) {
    ItemCategory["UNKNOWN"] = "UNKNOWN";
    ItemCategory["PHYSICAL"] = "PHYSICAL";
    ItemCategory["DIGITAL"] = "DIGITAL";
})(ItemCategory || (ItemCategory = {}));
export var RegistrarName;
(function (RegistrarName) {
    RegistrarName["UNKNOWN"] = "UNKNOWN";
    RegistrarName["REGISTER_DOT_COM"] = "REGISTER_DOT_COM";
    RegistrarName["TUCOWS"] = "TUCOWS";
    RegistrarName["WIX"] = "WIX";
})(RegistrarName || (RegistrarName = {}));
export var ICANNContactVerificationStatus;
(function (ICANNContactVerificationStatus) {
    ICANNContactVerificationStatus["VERIFICATION_STATUS_UNKNOWN"] = "VERIFICATION_STATUS_UNKNOWN";
    ICANNContactVerificationStatus["PENDING"] = "PENDING";
    ICANNContactVerificationStatus["DEACTIVATED"] = "DEACTIVATED";
    ICANNContactVerificationStatus["VERIFIED"] = "VERIFIED";
})(ICANNContactVerificationStatus || (ICANNContactVerificationStatus = {}));
export var LegalTypeEnum;
(function (LegalTypeEnum) {
    LegalTypeEnum["UNKNOWN"] = "UNKNOWN";
    /** Aboriginal */
    LegalTypeEnum["ABO"] = "ABO";
    /** Association */
    LegalTypeEnum["ASS"] = "ASS";
    /** CanadianCorporation */
    LegalTypeEnum["CCO"] = "CCO";
    /** CanadianCitizen */
    LegalTypeEnum["CCT"] = "CCT";
    /** Educational Institution */
    LegalTypeEnum["EDU"] = "EDU";
    /** Government */
    LegalTypeEnum["GOV"] = "GOV";
    /** Hospital */
    LegalTypeEnum["HOP"] = "HOP";
    /** IndianBand */
    LegalTypeEnum["INB"] = "INB";
    /** Library, Archive, or Museum */
    LegalTypeEnum["LAM"] = "LAM";
    /** Legal Representative */
    LegalTypeEnum["LGR"] = "LGR";
    /** Her Majesty the Queen */
    LegalTypeEnum["MAJ"] = "MAJ";
    /** Protected byTrademarks Act */
    LegalTypeEnum["OMK"] = "OMK";
    /** PoliticalParty */
    LegalTypeEnum["PLT"] = "PLT";
    /** Partnership */
    LegalTypeEnum["PRT"] = "PRT";
    /** Permanent Resident */
    LegalTypeEnum["RES"] = "RES";
    /** Trademark Owner */
    LegalTypeEnum["TDM"] = "TDM";
    /** TradeUnion */
    LegalTypeEnum["TRD"] = "TRD";
    /** Trust */
    LegalTypeEnum["TRS"] = "TRS";
})(LegalTypeEnum || (LegalTypeEnum = {}));
export var EntityTypeEnum;
(function (EntityTypeEnum) {
    EntityTypeEnum["UNKNOWN"] = "UNKNOWN";
    /** Italian resident */
    EntityTypeEnum["ITR"] = "ITR";
    /** Foreign resident; Resident/Company of the EEA (excluding Italy), the Swiss Confederation, the Republic of San Marino, or the Vatican City State */
    EntityTypeEnum["FOR"] = "FOR";
    /** Company or One man company */
    EntityTypeEnum["COM"] = "COM";
    /** Freelance worker */
    EntityTypeEnum["FWI"] = "FWI";
    /** Non profit organization */
    EntityTypeEnum["NPO"] = "NPO";
    /** Public organization */
    EntityTypeEnum["POI"] = "POI";
    /** Other subjects */
    EntityTypeEnum["OSI"] = "OSI";
})(EntityTypeEnum || (EntityTypeEnum = {}));
export var PolicyReasonEnum;
(function (PolicyReasonEnum) {
    PolicyReasonEnum["UNKNOWN"] = "UNKNOWN";
    /** The name exactly matches the acronym or abbreviation of the registrant's company or trading name, organization or association name, or trademark. */
    PolicyReasonEnum["EXC"] = "EXC";
    /** The name is connected closely and substantially to the registrant. */
    PolicyReasonEnum["CLS"] = "CLS";
})(PolicyReasonEnum || (PolicyReasonEnum = {}));
export var EligibilityTypeEnum;
(function (EligibilityTypeEnum) {
    EligibilityTypeEnum["UNKNOWN"] = "UNKNOWN";
    /** Company */
    EligibilityTypeEnum["COM"] = "COM";
    /** Sole Trader */
    EligibilityTypeEnum["STR"] = "STR";
    /** Partnership */
    EligibilityTypeEnum["PRT"] = "PRT";
    /** Trademark Owner */
    EligibilityTypeEnum["TRO"] = "TRO";
    /** Pending TM Owner */
    EligibilityTypeEnum["PTO"] = "PTO";
})(EligibilityTypeEnum || (EligibilityTypeEnum = {}));
export var EligibilityIdTypeEnum;
(function (EligibilityIdTypeEnum) {
    EligibilityIdTypeEnum["UNKNOWN"] = "UNKNOWN";
    /** Australian Business Number */
    EligibilityIdTypeEnum["ABN"] = "ABN";
    /** Australian Company Number */
    EligibilityIdTypeEnum["ACN"] = "ACN";
})(EligibilityIdTypeEnum || (EligibilityIdTypeEnum = {}));
export var BillingProviderType;
(function (BillingProviderType) {
    BillingProviderType["UNKNOWN"] = "UNKNOWN";
    BillingProviderType["SBS"] = "SBS";
    BillingProviderType["RESELLER"] = "RESELLER";
})(BillingProviderType || (BillingProviderType = {}));
export var RedeemStatusEnum;
(function (RedeemStatusEnum) {
    RedeemStatusEnum["UNKNOWN_REDEEM_STATUS"] = "UNKNOWN_REDEEM_STATUS";
    /** Domain is redemption period and can try to redeem */
    RedeemStatusEnum["CAN_REDEEM"] = "CAN_REDEEM";
    /** A transition status for when a redeem request is being processed */
    RedeemStatusEnum["REDEEM_IN_PROGRESS"] = "REDEEM_IN_PROGRESS";
    /** CC tries to redeem manually a domain and fails, usually because time has passed */
    RedeemStatusEnum["REDEEM_FAILED"] = "REDEEM_FAILED";
    /** Edge case: user will start a redeem intent when the domain redemption period is passed */
    RedeemStatusEnum["CANNOT_REDEEM"] = "CANNOT_REDEEM";
})(RedeemStatusEnum || (RedeemStatusEnum = {}));
export var AssetType;
(function (AssetType) {
    AssetType["DIGITAL_GOODS"] = "DIGITAL_GOODS";
    AssetType["MAILBOX"] = "MAILBOX";
    AssetType["SUBSCRIPTION"] = "SUBSCRIPTION";
    AssetType["DOMAIN"] = "DOMAIN";
})(AssetType || (AssetType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var SortType;
(function (SortType) {
    /** Should sort by number of matches */
    SortType["COUNT"] = "COUNT";
    /** Should sort by value of the field alphabetically */
    SortType["VALUE"] = "VALUE";
})(SortType || (SortType = {}));
export var SortDirection;
(function (SortDirection) {
    /** Should sort in descending order */
    SortDirection["DESC"] = "DESC";
    /** Should sort in ascending order */
    SortDirection["ASC"] = "ASC";
})(SortDirection || (SortDirection = {}));
export var MissingValues;
(function (MissingValues) {
    /** Should missing values be excluded from the aggregation results */
    MissingValues["EXCLUDE"] = "EXCLUDE";
    /** Should missing values be included in the aggregation results */
    MissingValues["INCLUDE"] = "INCLUDE";
})(MissingValues || (MissingValues = {}));
export var ScalarType;
(function (ScalarType) {
    ScalarType["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
    /** Count of distinct values */
    ScalarType["COUNT_DISTINCT"] = "COUNT_DISTINCT";
    /** Minimum value */
    ScalarType["MIN"] = "MIN";
    /** Maximum value */
    ScalarType["MAX"] = "MAX";
    /** Sum of values */
    ScalarType["SUM"] = "SUM";
    /** Average of values */
    ScalarType["AVG"] = "AVG";
})(ScalarType || (ScalarType = {}));
export var NestedAggregationType;
(function (NestedAggregationType) {
    NestedAggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** An aggregation where result buckets are dynamically built - one per unique value */
    NestedAggregationType["VALUE"] = "VALUE";
    /** An aggregation, where user can define set of ranges - each representing a bucket */
    NestedAggregationType["RANGE"] = "RANGE";
    /** A single-value metric aggregation - e.g. min, max, sum, avg */
    NestedAggregationType["SCALAR"] = "SCALAR";
    /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
    NestedAggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
})(NestedAggregationType || (NestedAggregationType = {}));
export var DateHistogramAggregationInterval;
(function (DateHistogramAggregationInterval) {
    DateHistogramAggregationInterval["UNKNOWN_INTERVAL"] = "UNKNOWN_INTERVAL";
    /** Yearly interval */
    DateHistogramAggregationInterval["YEAR"] = "YEAR";
    /** Monthly interval */
    DateHistogramAggregationInterval["MONTH"] = "MONTH";
    /** Weekly interval */
    DateHistogramAggregationInterval["WEEK"] = "WEEK";
    /** Daily interval */
    DateHistogramAggregationInterval["DAY"] = "DAY";
    /** Hourly interval */
    DateHistogramAggregationInterval["HOUR"] = "HOUR";
    /** Minute interval */
    DateHistogramAggregationInterval["MINUTE"] = "MINUTE";
    /** Second interval */
    DateHistogramAggregationInterval["SECOND"] = "SECOND";
})(DateHistogramAggregationInterval || (DateHistogramAggregationInterval = {}));
export var AggregationType;
(function (AggregationType) {
    AggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** An aggregation where result buckets are dynamically built - one per unique value */
    AggregationType["VALUE"] = "VALUE";
    /** An aggregation, where user can define set of ranges - each representing a bucket */
    AggregationType["RANGE"] = "RANGE";
    /** A single-value metric aggregation - e.g. min, max, sum, avg */
    AggregationType["SCALAR"] = "SCALAR";
    /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
    AggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
    /** Multi-level aggregation, where each next aggregation is nested within previous one */
    AggregationType["NESTED"] = "NESTED";
})(AggregationType || (AggregationType = {}));
export var Mode;
(function (Mode) {
    /** Any of the search terms must be present */
    Mode["OR"] = "OR";
    /** All search terms must be present */
    Mode["AND"] = "AND";
})(Mode || (Mode = {}));
export var PremiumStatus;
(function (PremiumStatus) {
    PremiumStatus["UNKNOWN_PREMIUM_STATUS"] = "UNKNOWN_PREMIUM_STATUS";
    /** Site does not have a premium plan connected to it */
    PremiumStatus["FREE"] = "FREE";
    /** Site has an active premium plan connected to it */
    PremiumStatus["PREMIUM"] = "PREMIUM";
})(PremiumStatus || (PremiumStatus = {}));
export var CrudType;
(function (CrudType) {
    CrudType["INVALID_CRUD_TYPE"] = "INVALID_CRUD_TYPE";
    CrudType["CREATE"] = "CREATE";
    CrudType["UPDATE"] = "UPDATE";
    CrudType["DELETE"] = "DELETE";
    /** Unfortunately this action is used by hibernate save in wix-war */
    CrudType["CREATE_OR_UPDATE"] = "CREATE_OR_UPDATE";
})(CrudType || (CrudType = {}));
export var BillingReferenceProviderName;
(function (BillingReferenceProviderName) {
    BillingReferenceProviderName["UNKNOWN"] = "UNKNOWN";
    BillingReferenceProviderName["SBS"] = "SBS";
    BillingReferenceProviderName["LICENSER"] = "LICENSER";
    BillingReferenceProviderName["BASS"] = "BASS";
    BillingReferenceProviderName["RESELLER"] = "RESELLER";
    BillingReferenceProviderName["RECURRING_INVOICES"] = "RECURRING_INVOICES";
})(BillingReferenceProviderName || (BillingReferenceProviderName = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["UNKNOWN"] = "UNKNOWN";
    SubscriptionStatus["AUTO_RENEW_ON"] = "AUTO_RENEW_ON";
    SubscriptionStatus["AUTO_RENEW_OFF"] = "AUTO_RENEW_OFF";
    SubscriptionStatus["MANUAL_RECURRING"] = "MANUAL_RECURRING";
    SubscriptionStatus["CANCELLED"] = "CANCELLED";
    SubscriptionStatus["TRANSFERRED"] = "TRANSFERRED";
})(SubscriptionStatus || (SubscriptionStatus = {}));
/** Reason for subscription reactivation */
export var ReactivationReasonEnum;
(function (ReactivationReasonEnum) {
    ReactivationReasonEnum["UNKNOWN"] = "UNKNOWN";
    /**
     * Subscription was reactivated due to billing status change from CANCELED to ACTIVE, for example if it was incorrectly
     * canceled because of suspicion of fraud
     */
    ReactivationReasonEnum["BILLING_STATUS_CHANGE"] = "BILLING_STATUS_CHANGE";
    /** Subscription was reactivated after a chargeback dispute */
    ReactivationReasonEnum["REACTIVATED_AFTER_CHARGEBACK"] = "REACTIVATED_AFTER_CHARGEBACK";
})(ReactivationReasonEnum || (ReactivationReasonEnum = {}));
export var Initiator;
(function (Initiator) {
    Initiator["UNKNOWN"] = "UNKNOWN";
    Initiator["USER_REQUESTED"] = "USER_REQUESTED";
    Initiator["APP_MANAGED"] = "APP_MANAGED";
    Initiator["PASSIVE"] = "PASSIVE";
})(Initiator || (Initiator = {}));
export var UnassignReason;
(function (UnassignReason) {
    UnassignReason["UNKNOWN"] = "UNKNOWN";
    UnassignReason["USER_REQUESTED"] = "USER_REQUESTED";
    UnassignReason["REPLACED_BY_ANOTHER_SUBSCRIPTION"] = "REPLACED_BY_ANOTHER_SUBSCRIPTION";
})(UnassignReason || (UnassignReason = {}));
/** Copied from SBS */
export var ContractSwitchType;
(function (ContractSwitchType) {
    ContractSwitchType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    ContractSwitchType["ADDITIONAL_QUANTITY"] = "ADDITIONAL_QUANTITY";
    ContractSwitchType["CREDIT_UNUSED_PERIOD"] = "CREDIT_UNUSED_PERIOD";
    ContractSwitchType["REFUND_PRICE_DIFF"] = "REFUND_PRICE_DIFF";
    ContractSwitchType["ADJUST_PERIOD_END"] = "ADJUST_PERIOD_END";
    ContractSwitchType["DOWNGRADE_GRACE_PERIOD"] = "DOWNGRADE_GRACE_PERIOD";
    ContractSwitchType["FULL_AMOUNT_PERIOD"] = "FULL_AMOUNT_PERIOD";
    ContractSwitchType["END_OF_PERIOD"] = "END_OF_PERIOD";
    ContractSwitchType["PENDING_CHANGES"] = "PENDING_CHANGES";
    ContractSwitchType["DOWNGRADE_RENEWAL"] = "DOWNGRADE_RENEWAL";
})(ContractSwitchType || (ContractSwitchType = {}));
export var ContractSwitchReason;
(function (ContractSwitchReason) {
    ContractSwitchReason["EXTERNAL_PROVIDER_TRIGGER"] = "EXTERNAL_PROVIDER_TRIGGER";
    ContractSwitchReason["PRICE_INCREASE"] = "PRICE_INCREASE";
})(ContractSwitchReason || (ContractSwitchReason = {}));
/** Reason for Price Increase Trigger */
export var PriceIncreaseTrigger;
(function (PriceIncreaseTrigger) {
    PriceIncreaseTrigger["NEAR_RENEWAL"] = "NEAR_RENEWAL";
    PriceIncreaseTrigger["RECURRING_SUCCESS"] = "RECURRING_SUCCESS";
    PriceIncreaseTrigger["MANUAL"] = "MANUAL";
})(PriceIncreaseTrigger || (PriceIncreaseTrigger = {}));
/** Triggered when a subscription's product is adusted. */
export var ProductAdjustment;
(function (ProductAdjustment) {
    /** flag to show that the ContractSwitchedEvent is not applicable / needed */
    ProductAdjustment["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    /** flag to show that the ContractSwitchedEvent is a Downgrade */
    ProductAdjustment["DOWNGRADE"] = "DOWNGRADE";
})(ProductAdjustment || (ProductAdjustment = {}));
export var ContactVerificationStatus;
(function (ContactVerificationStatus) {
    ContactVerificationStatus["PENDING"] = "PENDING";
    ContactVerificationStatus["DEACTIVATED"] = "DEACTIVATED";
    ContactVerificationStatus["CONFIRMED_BY_WIX"] = "CONFIRMED_BY_WIX";
    ContactVerificationStatus["CONFIRMED_BY_REGDOTCOM"] = "CONFIRMED_BY_REGDOTCOM";
})(ContactVerificationStatus || (ContactVerificationStatus = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
/** Enumerates the days of the week. */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
//# sourceMappingURL=types.impl.js.map